import React, { useState, useRef, useEffect } from "react";
import MetaTags from "react-meta-tags";
import Popup from "reactjs-popup";
import PropTypes from "prop-types";
import {
  Button,
  Alert,
  Col,
  Container,
  Form,
  Card,
  CardBody,
  Label,
  Row,
} from "reactstrap";

import "reactjs-popup/dist/index.css";
import SignaturePad from "react-signature-canvas";
import "./sigCanvas.css";

import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, useParams } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";

import { informesList, informesCreate } from "../../store/informes/actions";
import { casosUpdate, casosLista } from "../../store/casos/actions";

const InformesAdd = (props) => {
  const sigCanvas = useRef({});
  const dispatch = useDispatch();
  const history = useHistory();
  const user1 = JSON.parse(localStorage.getItem("user"));
  const usuarioCrea = user1.id;
  const popupRef = useRef();

  function handleClose() {
    popupRef.current.close();
  }
  const param = useParams();
  const str = param.id;
  const casosId = Number(str);

  useEffect(() => {
    dispatch(casosLista());
    dispatch(informesList());
  }, [dispatch]);


  const caso = casosId;
  const user = usuarioCrea;

  const limpiar = () => sigCanvas.current.clear();

  const [imageUrl, setImageUrl] = useState(null);
  const [imageUrl1, setImageUrl1] = useState(null);

  const [image, setFormDataImage] = useState([]);

 

  const [formData, setFormData] = useState({
    informe_visita: "",
    repuesto_materiales: "",
    observaciones: "",
    persona_recibe_servicio: "",
    cargo_persona_recibe_servicio: "",
  });

  const {
    informe_visita,
    repuesto_materiales,
    observaciones,
    persona_recibe_servicio,
    cargo_persona_recibe_servicio,
  } = formData;

  const onChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setFormData({ ...formData, [e.target.name]: uppercaseValue });
  };

  const guardar = () => {
    const imageUrl = sigCanvas.current.toDataURL("image/png");
    const cleanImageUrl = imageUrl.substring("data:image/png;base64,".length);
    setImageUrl(cleanImageUrl);
    setImageUrl1(imageUrl);
    handleClose();
  };

  const handleImageChange = (evImages) => {
    Array.from(evImages).forEach((image) => {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataImage((prevImages) => [...prevImages, { image: img[1] }]);
      };
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const data = {
      informe_visita,
      repuesto_materiales,
      observaciones,
      persona_recibe_servicio,
      cargo_persona_recibe_servicio,
      caso,
      user,
      estatus_informe: "FINALIZAR",
      images: image,
    };

    if (imageUrl !== null) {
      data.firma = imageUrl;
    }

    props.informesCreate(data);
  };

  const handlePausaclick = () => {
    dispatch(
      casosUpdate(casosId, {
        estatus: "PAUSAR",
      })
    );
    props.informesCreate({
      informe_visita,
      repuesto_materiales,
      observaciones,
      persona_recibe_servicio,
      cargo_persona_recibe_servicio,
      caso,
      user,
      firma: imageUrl !== null ? imageUrl : "",
      estatus_informe: "PAUSAR",
    });

    history.push("/casos");
  };

  const redirect = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> crear nueva visita tecnica </title>
        </MetaTags>
        <Container fluid>
          <Breadcrumb breadcrumbItem={"Informes"} />
          {props.loading ? (
            <Loader />
          ) : (
            <>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        onClick={redirect}
                      >
                        Ir a Atras
                      </button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Row className="justify-content-center">
                {props.informesCreated.id ? (
                  <SweetAlert
                    title="Hecho!"
                    success
                    timeout={1000}
                    showConfirm={false}
                    onConfirm={() => {
                      redirect();
                    }}
                  >
                    Se ha agregado el Informe
                  </SweetAlert>
                ) : null}

                <h4 className="card-title">Crear Nueva visita tecnica</h4>

                <Form
                  className="form-control needs-validation justify-content-center"
                  onSubmit={onSubmit}
                >
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="informe_visita"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Informe Visita</strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="informe_visita"
                        name="informe_visita"
                        type="textarea"
                        rows="4"
                        onChange={onChange}
                        value={informe_visita}
                      />

                      {props.error && props.error.informe_visita ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.informe_visita}
                        </Alert>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="repuesto_materiales"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Repuestos y/o Materiales </strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="repuesto_materiales"
                        name="repuesto_materiales"
                        type="textarea"
                        rows="4"
                        onChange={onChange}
                        value={repuesto_materiales}
                      />

                      {props.error && props.error.repuesto_materiales ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.repuesto_materiales}
                        </Alert>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="observaciones"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Observaciones</strong>
                      </Label>

                      <textarea
                        className="form-control"
                        id="observaciones"
                        name="observaciones"
                        type="textarea"
                        rows="4"
                        onChange={onChange}
                        value={observaciones}
                      />
                    </Col>

                    {props.error && props.error.observaciones ? (
                      <Alert color="danger" className="mt-2">
                        {props.error.observaciones}
                      </Alert>
                    ) : null}
                  </Row>

                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={6} className="mb-10">
                      <Label
                        for="image"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Imagenes (Opcional) </strong>
                      </Label>

                      <input
                        className="form-control"
                        id="image"
                        name="image"
                        type="file"
                        multiple={true}
                        onChange={(e) => handleImageChange(e.target.files)}
                      />
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center">
                    <Col lg={3} className="mb-10">
                      <Label
                        for="persona_recibe_servicio"
                        className="col-form-label col-sm-6 d-flex"
                      >
                        <strong>Persona Contacto</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="persona_recibe_servicio"
                        name="persona_recibe_servicio"
                        type="text"
                        onChange={onChange}
                        value={persona_recibe_servicio}
                      />
                      {props.error && props.error.persona_recibe_servicio ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.persona_recibe_servicio}
                        </Alert>
                      ) : null}
                    </Col>

                    <Col lg={3} className="mb-10">
                      <Label
                        for="cargo_persona_recibe_servicio"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>Cargo</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="cargo_persona_recibe_servicio"
                        name="cargo_persona_recibe_servicio"
                        type="text"
                        onChange={onChange}
                        value={cargo_persona_recibe_servicio}
                      />
                      {props.error &&
                      props.error.cargo_persona_recibe_servicio ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.cargo_persona_recibe_servicio}
                        </Alert>
                      ) : null}
                    </Col>

                    <div className="example-warper mt-2">
                      <Popup
                        ref={popupRef}
                        trigger={
                          <button type="button" className="button">
                            Firma aqui
                          </button>
                        }
                        modal
                        closeOnDocumentClick={false}
                      >
                        {(close) => (
                          <>
                            <SignaturePad
                              ref={sigCanvas}
                              canvasProps={{
                                className: "signatureCanvas",
                              }}
                            />
                            <button className="button" onClick={close}>
                              Cerrar
                            </button>
                            <button className="button" onClick={limpiar}>
                              limpiar
                            </button>

                            <button className="button" onClick={guardar}>
                              guardar
                            </button>
                          </>
                        )}
                      </Popup>
                      {props.error && props.error.firma ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.firma}
                        </Alert>
                      ) : null}
                    </div>
                    {imageUrl1 ? (
                      <img
                        src={imageUrl1}
                        alt="mi firma"
                        style={{
                          display: "block",
                          margin: "0 auto",
                          border: "1px solid blick",
                          width: "150px",
                        }}
                      />
                    ) : null}
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-2">
                    <Col md={1} className="mx-1">
                      <Button color="primary" type="submit">
                        FINALIZAR
                      </Button>
                    </Col>
                    <Col md={1} className="mx-1 ">
                      <Button
                        color="primary"
                        type="button"
                        onClick={(e) => handlePausaclick()}
                      >
                        PAUSAR
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, informesCreated } = state.Informes;
  const { casosUpdated, casos } = state.Casos;
  return { error, loading, informesCreated, casosUpdated, casos };
};

InformesAdd.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  informesCreated: PropTypes.object,
  casosUpdated: PropTypes.object,
  casos: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, { informesCreate, casosUpdate, casosLista })(
    InformesAdd
  )
);
